document.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.querySelector('.language-dropdown');

  if (!dropdown) return;

  // Закрити при кліку поза меню
  document.addEventListener('click', (event) => {
    if (!dropdown.contains(event.target)) {
      dropdown.removeAttribute('open');
    }
  });

  // Закрити по Esc
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      dropdown.removeAttribute('open');
    }
  });
});